import type { Editor } from '@tiptap/core';
import { NodeSelection } from '@tiptap/pm/state';

const RGB = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/;

const toHex = (value: string): string | undefined => {
	const match = RGB.exec(value);
	if (!match) {
		return value.startsWith('#') ? value : undefined;
	}
	return `#${match
		.slice(1, 4)
		.map((channel) => Number(channel).toString(16).padStart(2, '0'))
		.join('')}`;
};

// How the selection renders right now, inherited styles included: the editor's
// own getters only report what a node carries itself.
export const effectiveStyleValue = (
	editor: Editor,
	property: 'color' | 'fontSize'
): string | undefined => {
	const { selection } = editor.state;
	const position = () => {
		if (selection instanceof NodeSelection) {
			return selection.from;
		}
		return selection.$from.depth > 0
			? selection.$from.before(selection.$from.depth)
			: undefined;
	};
	const at = position();
	const dom = at === undefined ? editor.view.dom : editor.view.nodeDOM(at);
	const element = dom instanceof HTMLElement ? dom : editor.view.dom;
	if (!(element instanceof HTMLElement)) {
		return undefined;
	}
	const styles = getComputedStyle(element);
	return property === 'color' ? toHex(styles.color) : styles.fontSize;
};
